import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';

import { LanguageService } from '@fcom/ui-translate';
import { ModalButtons } from '@fcom/ui-components/components/modal/interfaces';
import { ConfigService } from '@fcom/core/services/config/config.service';

@Component({
  selector: 'fin-content-with-modal',
  styleUrls: ['content-with-modal.component.scss'],
  templateUrl: 'content-with-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContentWithModalComponent {
  private languageService = inject(LanguageService);
  private configService = inject(ConfigService);

  @Input() content: string;
  @Input() title?: string;

  public readonly ModalButtons = ModalButtons;

  modalOpen = false;
  cmsUrl: string;

  openModalIfLink(event: Event): void {
    const target = event.target as HTMLElement | null;

    if (
      target &&
      typeof target.tagName === 'string' &&
      target.tagName.toLowerCase() === 'a' &&
      target.getAttribute('data-contentid')
    ) {
      const contentId: string = target.getAttribute('data-contentid');
      this.cmsUrl = `${this.configService.cmsUrl}/service/json/v1/ids/${this.languageService.langValue}/${contentId}`;
      this.modalOpen = true;
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
